import React from "react"
import Donate from "../base-pages/donate"

const DonateCN = () => {
  return <Donate lang="cn" />
}

export default DonateCN
